import isEmpty from 'lodash.isempty'
import omitBy from 'lodash.omitby'

export function omitByEmptyKeepBooleans(params) {
  return omitBy(params, (value) => {
    if (value === null || value === undefined) return true
    if (typeof value === 'string' && value.trim() === '') return true
    if (Array.isArray(value) && value.length === 0) return true
    if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
      return true
    }
    return false
  })
}

function buildParamList(params) {
  if (isEmpty(params)) return ''
  try {
    let returnedParams = '?'
    if (typeof params === 'object') {
      const allParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (Array.isArray(value)) {
          acc.push(`${key}=${value.join()}`)
        } else {
          acc.push(`${key}=${value}`)
        }
        return acc
      }, [])
      returnedParams += allParams.join('&')
    }
    return returnedParams
  } catch (error) {
    return new Error(error)
  }
}

export default buildParamList
